import { io } from 'socket.io-client';
import { API_BASE_URL } from '../../config/api-config';

// const socketUrl = API_BASE_URL ? API_BASE_URL.replace(/\/api\/?$/, '') : window.location.origin;

// export const socketSetup = io(API_BASE_URL, {
//     // Defines the Socket.IO endpoint path configured on the backend and IIS.
//     path: '/api/socket.io',

//     // Uses HTTP long-polling initially and allows upgrading to WebSocket when supported.
//     // transports: ['polling', 'websocket'],
//     transports: ['polling'],

//     // Allows cookies and credentials to be included in eligible cross-origin requests.
//     withCredentials: true,

//     // Automatically attempts to reconnect when the connection is lost.
//     reconnection: true,

//     // Stops automatic reconnection after 10 unsuccessful attempts.
//     reconnectionAttempts: 10,

//     // Sets the initial delay between reconnection attempts to 1 second.
//     reconnectionDelay: 1000,

//     // Limits the delay between reconnection attempts to a maximum of 5 seconds.
//     reconnectionDelayMax: 5000,

//     // Sets the connection attempt timeout to 20 seconds.
//     timeout: 20000,
// });

const socketOptions = {
    path: '/api/socket.io',
    transports: ['polling'],
    withCredentials: true,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
};

// Existing System 1 chat connection
export const socketSetup = io(API_BASE_URL, socketOptions);

// System 2 chat connection
// export const system2SocketSetup = io(SYSTEM2_API_URL, socketOptions);

// Connected
// socketSetup.on('connect', () => {
//     console.log('==============================');
//     console.log('Connected to socket server');
//     console.log('Socket ID:', socketSetup.id);
//     console.log('==============================');
// });

// // Welcome event from backend
// socketSetup.on('welcome', (message) => {
//     console.log('Server Message:', message);
// });

// // Receive message from backend
// socketSetup.on('receiveMessage', (data) => {
//     console.log('Received from server:', data);
// });

// // Disconnected
// socketSetup.on('disconnect', () => {
//     console.log('Disconnected from socket server');
// });

// Error
// socketSetup.on('connect_error', (err) => {
//     console.log('Socket Connection Error:', err.message);
// });